// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "创新创业基础（一）",
      "tec": "张国伟",
      "week": "1-7,9-13周",
      "add": "教学A座128机械双创中心"
    },
    [
      {
        "sub": "热工基础与流体力学",
        "tec": "张瑞青",
        "week": "1-7,9-10单周",
        "add": "教学楼A座319机械"
      },
      {
        "sub": "现代设计基础Ⅲ",
        "tec": "李祥松",
        "week": "2-3双周",
        "add": "教学楼A座418机械"
      },
      {
        "sub": "现代设计基础Ⅲ",
        "tec": "郭维城李祥松罗旋",
        "week": "6,10,12双周",
        "add": "教学楼A座418机械"
      }
    ],
    [
      {
        "sub": "能源电力工程英语（下）",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "24自机2-3（能电）",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "24自机2-1（能电）",
        "tec": "杨欣瑶丁璐瑶",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "24自机2-2（能电）",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "24自机2-4（能电）",
        "tec": "刘亚梅",
        "week": "1-14周",
        "add": "教学楼A座417机械"
      },
      {
        "sub": "24自机1-5",
        "tec": "韩英焕",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "24自机1-3",
        "tec": "徐亮",
        "week": "1-14周",
        "add": "教学楼B座121自控"
      },
      {
        "sub": "24自机1-4",
        "tec": "苏欣",
        "week": "1-12,14周",
        "add": "教学楼A座418机械"
      },
      {
        "sub": "24自机1-2",
        "tec": "徐常翠",
        "week": "1-14周",
        "add": "教学楼A座318机械"
      },
      {
        "sub": "24自机1-1",
        "tec": "李英杰田甜",
        "week": "16-18周",
        "add": "教学楼A座420机械"
      }
    ],
    {
      "sub": "现代设计基础Ⅲ",
      "tec": "关萌",
      "week": "4周",
      "add": "教学楼A座418机械"
    },
    0
  ],
  "2": [
    0,
    [
      {
        "sub": "体育（四）",
        "tec": "任德鑫",
        "week": "1-2,4-6,8-17周",
        "add": "男网"
      },
      {
        "sub": "足球场2",
        "tec": "李庆",
        "week": "1-17周",
        "add": "男网"
      },
      {
        "sub": "轮滑",
        "tec": "贾思敏",
        "week": "1-17周",
        "add": "男网"
      },
      {
        "sub": "男篮",
        "tec": "高佳",
        "week": "1-17周",
        "add": "男网"
      },
      {
        "sub": "男乒",
        "tec": "朱永",
        "week": "1-17周",
        "add": "男网"
      },
      {
        "sub": "男排",
        "tec": "李灏",
        "week": "1-17周",
        "add": "男网"
      },
      {
        "sub": "搏击",
        "tec": "王文娇",
        "week": "1-17周",
        "add": "男网"
      },
      {
        "sub": "女羽",
        "tec": "王莹莹",
        "week": "1-12,14-17周",
        "add": "男网"
      },
      {
        "sub": "男网",
        "tec": "任德鑫",
        "week": "3周",
        "add": "男网"
      },
      {
        "sub": "足球场1",
        "tec": "任德鑫",
        "week": "7周",
        "add": "男网"
      },
      {
        "sub": "足球场2",
        "tec": "田海燕",
        "week": "13周",
        "add": "男网"
      }
    ],
    [
      {
        "sub": "中国近现代史纲要",
        "tec": "夏彬",
        "week": "1-7,10-13周",
        "add": "教学楼C座110教务"
      },
      {
        "sub": "中国近现代史纲要",
        "tec": "夏彬",
        "week": "14周",
        "add": "教学楼C座110教务"
      }
    ],
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "1-4周",
      "add": "教学楼C座212教务"
    },
    0
  ],
  "3": [
    {
      "sub": "电子技术",
      "tec": "赵东升",
      "week": "1-7,9-17周",
      "add": "教学楼A座420机械"
    },
    [
      {
        "sub": "材料力学",
        "tec": "王琳张修路",
        "week": "1-7,9-13周",
        "add": "教学楼A座319机械"
      },
      {
        "sub": "工程化学",
        "tec": "李英杰田甜",
        "week": "15-16周",
        "add": "教学楼A座420机械"
      },
      {
        "sub": "工程化学",
        "tec": "李英杰田甜",
        "week": "17周",
        "add": "教学楼A座420机械"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "能源电力工程英语（下）",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "24自机2-1（能电）",
        "tec": "刘亚梅",
        "week": "1-14周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "24自机1-5",
        "tec": "杨欣瑶丁璐瑶",
        "week": "1-14周",
        "add": "实训楼F座101自控"
      },
      {
        "sub": "24自机2-2（能电）",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "24自机2-3（能电）",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "教学楼B座121自控"
      },
      {
        "sub": "24自机2-4（能电）",
        "tec": "徐常翠",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "24自机1-1",
        "tec": "苏欣",
        "week": "1-14周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "24自机1-2",
        "tec": "韩英焕",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "24自机1-3",
        "tec": "徐亮",
        "week": "1-14周",
        "add": "实训楼E座403语音室"
      }
    ],
    [
      {
        "sub": "中国近现代史纲要",
        "tec": "夏彬",
        "week": "1-7,10-13周",
        "add": "教学楼C座110教务"
      },
      {
        "sub": "中国近现代史纲要",
        "tec": "夏彬",
        "week": "14周",
        "add": "教学楼C座110教务"
      }
    ],
    [
      {
        "sub": "现代设计基础Ⅲ",
        "tec": "李祥松",
        "week": "1-3周",
        "add": "教学楼A座419机械"
      },
      {
        "sub": "现代设计基础Ⅲ",
        "tec": "郭维城李祥松罗旋",
        "week": "4-7,9-12周",
        "add": "教学楼A座419机械"
      }
    ],
    0,
    {
      "sub": "大学英语（四）",
      "tec": "苏欣",
      "week": "11周",
      "add": "实训楼E座401管理"
    }
  ],
  "5": [
    {
      "sub": "工程伦理",
      "tec": "李震金钰",
      "week": "1-7,9周",
      "add": "教学楼C座110教务"
    },
    [
      {
        "sub": "热工基础与流体力学",
        "tec": "张瑞青",
        "week": "1-7,9-12周",
        "add": "教学楼A座319机械"
      },
      {
        "sub": "工程化学",
        "tec": "李英杰田甜",
        "week": "13-18周",
        "add": "教学楼A座420机械"
      }
    ],
    {
      "sub": "材料力学",
      "tec": "王琳张修路",
      "week": "1-7,9-13周",
      "add": "教学楼A座318机械"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
